define(function(require, exports, module) {
    'use strict';

    var core = require('core');
    var user = require('user');
    var $ = require('j');
    var _ = require('underscore');
    var config = require('config');
    var StickyFooterModelInstance = require('replacers/totalcasino-theme/sticky-footer/base.sticky-footer.model.instance');
    var BaseReplacerView = require('common/base.replacer.view');
    var gamesInfo = require('portlets/games-info/totalcasino-theme/gamesinfo.view');

    module.exports = BaseReplacerView.extend({

        model: StickyFooterModelInstance,

        events: {
            'tap .fn-favorites': 'toggleGameFavorites'
        },

        toggleGameFavorites: function(e) {
            gamesInfo.prototype.toggleGameFavorites(e);
        },

        subscribe: function() {
            this.listenTo(core, {
                'gameFavoritesChange:success': this.updateFavoriteGames.bind(this)
            });
        },

        initialize: function() {
            BaseReplacerView.prototype.initialize.apply(this, arguments);

            this.maxGamesLengthAllowed = this.model.get('maxGamesLengthAllowed');
            this.maxGamesFavoritesLengthAllowed = this.model.get('maxGamesFavoritesLengthAllowed');
            this.isLoggedIn = user.isLogin();
            this.isLoggedIn && this.model.getFavoriteGames();
        },

        render: function() {
            this.isLoggedIn ? this.renderForUser() : this.getGamesFromWebcontent();

            return this;
        },

        renderForUser: function() {
            var games = this.model.get('favoriteGames').slice(0, this.maxGamesLengthAllowed);
            this.$el.html(this.tmpl('favorites', games));

            if (games.length < this.maxGamesLengthAllowed) {
                var deltaGamesFromWClength = this.maxGamesLengthAllowed - games.length;
                this.getGamesFromWebcontent(deltaGamesFromWClength, games);
            } else {
                core.trigger('footer-games:loaded', this.$el);
            }
            return this;
        },

        getGamesFromWebcontent: function(deltaGamesFromWClength, addedByUserGames) {
            var content = config.get('webcontentStickyFooterFavorites') || 'STICKY-FOOTER-FAVORITES';
            var gamesFromWClength;

            this.loadContent(content).done(function(html) {
                if (!this.$el.find('.favorite-games').length) {
                    this.$el.html(this.tmpl('favorites'));
                }

                if (deltaGamesFromWClength) {
                    gamesFromWClength = deltaGamesFromWClength > this.maxGamesFavoritesLengthAllowed ? this.maxGamesFavoritesLengthAllowed : deltaGamesFromWClength;
                } else {
                    gamesFromWClength = this.maxGamesFavoritesLengthAllowed;
                }

                var games = $(html);

                if(addedByUserGames) {
                    var addedByUserGamesCodes = _.pluck(addedByUserGames, 'gameCode');
                    games = games.filter(function(game) {
                        return !addedByUserGamesCodes.includes(game.dataset.gameCode);
                    });
                }

                var gamesFromWebContentEl = games.slice(0, gamesFromWClength);

                this.$el.find('.favorite-games').append(gamesFromWebContentEl);

                core.trigger('footer-games:loaded', this.$el);
            }.bind(this));
        },

        updateFavoriteGames: function() {
            this.model.getFavoriteGames();
            this.render();
        }
    }, {
        nameOfReplacers: [
            'STICKY_FOOTER_FAVORITES'
        ]
    });
});
